import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { FormControl } from '@angular/forms';
import { CommerceService } from '../../../core/service/app/commerce.service';
import { AppState } from '../../../store/app-state';
import { Store } from '@ngrx/store';
import { Alert } from 'selenium-webdriver';

@Component({
  selector: 'app-commerce-casefile-form',
  templateUrl: './commerce-casefile-form.component.html',
  styleUrls: ['./commerce-casefile-form.component.scss']
})
export class CommerceCasefileFormComponent extends FormBaseComponent<any> implements OnInit {
  files: { [name: string]: number } = {}
  list = [];
  
  userid;

  valido: boolean = true;
  completados = [];

  @Input() showCotejo = false;
  @Input() enRegistro: boolean;
  
  @Input() idTipoPersona: number = 0;

  @Output() esPaso4Valido = new EventEmitter<any>();
  
  constructor(private commerceService: CommerceService, private store: Store<AppState>) {
    super();
    
    this.store.subscribe(state => {
      if (state.user.isAuth) {
        this.userid = state.user.data.id
      }

    });

  }
  
  flag = true;

  ngOnInit() {
    this.init();
    this.commerceService.dataSub.subscribe(state =>{
      if (state) {
        if(this.idTipoPersona != 0 && this.list.length == 0)
        {
          this.commerceService.getAllFiles(this.idTipoPersona, this.enRegistro )
          .then(result => {
            this.completados = [];
            this.list = result;
            this.list.forEach(item => {
              this.completados.push(!item.requerido);
            });
          });
        }
      }
    });
  }

  /*addToList(data, index) {
    let temp: { [name: string]: number } = {};
    temp['file' + (index)] = data.id;
    this.form.patchValue(temp)
    this.commerceService.saveWizardFile(this.form.value);    
  }*/

  addToList(data, i)
  {
    this.valido = true;
    if(!this.completados[i])
    {
      if(data== null)
      {
        this.completados[i] = false;
      }
      else
      {
        this.completados[i] = true;
      }
      
      this.completados.forEach(item => {
        if(item == false){ this.valido = false; }
      });
      //console.log(this.completados);
      //console.log(this.valido);
      //if(data == null){ this.valido = false; }
    }
    //this.esPaso4Valido.emit(this.valido);
  }

  

}



// WEBPACK FOOTER //
// ./src/app/form/form/commerce-casefile-form/commerce-casefile-form.component.ts